import React, { useRef, useEffect, useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import BlockRenderer from './ComplexBlockRenderer';
import { useDocumentContext } from '../../context/complexDocumentContext';
import { useArtboardContext, CONTEXT_KEYS } from '../../context/complexArtboardContext';
import { block_Selection } from '../../utils/helper';

const NAMESPACES = ['COMPLEX_PAGE_OPTIONS'];

const PageStaticElement = ({
  t,
  uuid,
  blockUUID,
  elementType,
  editable,
  pageRef,
  pageId,
  customClassName,
  scaling,
  getElementStyles,
  isStandaloneFlow
}) => {
  const dependentRef = useRef(null);

  useEffect(() => {
    dependentRef.current = pageRef.current?.querySelector(`.${customClassName}`);
  }, [customClassName, pageRef]);

  const standaloneSelector = useCallback(store => (store[blockUUID].isStandalone), []);
  const [isStandaloneHeaderOrFooter] = useDocumentContext(standaloneSelector, `ComplexPage-${uuid}`);

  const customSelector = useCallback(() => null , []);
  const [, methods] = useDocumentContext(customSelector, `blockLayout-${uuid}`);

  const selectedBlockSelector = useCallback(store => store[CONTEXT_KEYS.SELECTED_BLOCKS], []);
  const [selectedBlocks, updateArtboard] = useArtboardContext(selectedBlockSelector, `blockLayout-${uuid}`);

  const selectedBlocksParentSelector = useCallback(
    store => store[CONTEXT_KEYS.SELECTED_BLOCKS_PARENT],
    [],
  );
  const [selectedBlocksParent] = useArtboardContext(
    selectedBlocksParentSelector,
    `blockLayout-${uuid}`,
  );

  const headerOrFooterSelectedSelector = useCallback(
    store => store[CONTEXT_KEYS.HEADER_OR_FOOTER_BLOCK_SELECTED],
    [],
  );
  const [isHeaderOrFooterSelected] = useArtboardContext(
    headerOrFooterSelectedSelector,
    `blockLayout-${uuid}`,
  );

  const contentSelectedSelector = useCallback(
    store => store[CONTEXT_KEYS.CONTENT_BLOCK_SELECTED],
    [],
  );
  const [isContentSelected] = useArtboardContext(
    contentSelectedSelector,
    `blockLayout-${uuid}`,
  );

  const disableVariablesSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN] || store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [disableVariables] = useArtboardContext(disableVariablesSelector, `PageStaticElement`);

  const blockSelection = useCallback(({itemUUID, parentUUID}) => {
    if (disableVariables) return;
    block_Selection({
      selectedBlocks,
      itemUUID,
      parentUUID,
      flowDetails: methods.get()[parentUUID],
      selectedBlocksParent,
      isHeaderOrFooterSelected,
      isContentSelected,
      updateArtboard,
      methods,
      t
    });
  }, [
    isContentSelected,
    isHeaderOrFooterSelected,
    methods,
    selectedBlocks,
    selectedBlocksParent,
    updateArtboard,
    t,
    disableVariables
  ]);

  return (
    <div style={{ position: 'relative' }}>
    <BlockRenderer
      itemUUID={blockUUID}
      editable={editable}
      blockIsEditable = {!isStandaloneHeaderOrFooter}
      parentUUID={uuid}
      dependentRef={dependentRef}
      type={elementType}
      pageId={pageId}
      scaling={scaling}
      getElementStyles={getElementStyles}
      onClickBlockSelection= {blockSelection}
      isStandaloneFlow={isStandaloneFlow}
    />
    </div>
  );
};

export default React.memo(withTranslation(NAMESPACES)(PageStaticElement));
